import clsx from 'clsx';
import { useRef } from 'react';
import { RatingStars, Typography } from '@ag1/ui';
import useAddAccessibility from 'shared/hooks/addAccessibility';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { ValueReviewCards } from 'types/studio/studio';
import styles from './ReviewCard.module.scss';

type Props = { open: boolean } & ValueReviewCards['cards'][number]['expandedData'];

export const ExpandedBlock = ({
  open,
  headline,
  description,
  reviewHeadline,
  reviewText,
  reviewAuthor
}: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useAddAccessibility(contentRef, true);
  return (
    <div className={clsx(styles.expandedBlock, open && styles.open)} ref={contentRef}>
      <Typography
        className={styles.expandedBlockHeadline}
        variant="headlineSans"
        size="3"
        color="black-new"
        noPadding>
        {headline}
      </Typography>
      {description && <CustomPortableText value={description} className={styles.description} />}
      <div className={styles.divider} />
      <RatingStars
        rating={5}
        childClassName={styles.ratingStars}
        className={styles.ratingStarsContainer}
        thin
        inheritFontSize
      />
      <Typography variant="subtitle" size="2" color="black-new" noPadding>
        {reviewHeadline}
      </Typography>
      <Typography variant="body" size="2" color="black-new" fontStyle="italic" noPadding>
        <CustomPortableText value={reviewText} className={styles.reviewText} />
      </Typography>
      <Typography variant="caption" size="1" color="grey-1-new" noPadding className={styles.author}>
        {reviewAuthor}
      </Typography>
    </div>
  );
};
